import { css } from 'styled-components';
import { pxToRem } from 'modules/spacing';
import { interactiveTransition, themeGet } from 'modules/tetrisTheme';
/**
 * The shared chrome every button in the family paints: typography, border box,
 * flex centring and the focus/disabled contract.
 */
export const buttonBase = css `
  white-space: nowrap;
  appearance: none;
  text-decoration: none;
  box-sizing: border-box;
  font-style: normal;
  font-weight: ${themeGet('fontWeight.medium')};
  font-size: ${themeGet('fontSize.medium')};
  line-height: ${themeGet('lineHeight.default')};
  border-style: solid;
  border-width: ${pxToRem(1)};
  border-radius: ${themeGet('borderRadius.md')};
  display: flex;
  justify-content: center;
  align-items: center;
  column-gap: ${themeGet('spacing.md')};

  &:disabled {
    pointer-events: none;
  }

  &:not(:disabled) {
    cursor: pointer;
  }

  &:focus-visible {
    outline: none;
  }

  ${interactiveTransition};
`;
